import { gql } from '@apollo/client'

export default gql(`
    query listDisplayType($limit: Int $project: String){
        listDisplayType( 
            limit: $limit
            project: $project
            ) {
        items {
            id
            name
            key
            usedCount
        }
    }
}`)
